export const PAYMENTS_TYPES = {
  CONTRACT: 'CONTRACT',
  EXTRA_CHARGES: 'Pago de cargos extra',
  RESERVATION: 'Pago de reservación',
};
